export default {
    navStore: require("./navStore"),
    gatewayStore: require("./gatewayStore"),
    userStore: require("./userStore"),
    authStore: require("./authStore")
};



/** WEBPACK FOOTER **
 ** ./app/stores/index.js
 **/